import { createSelector } from 'reselect';

const metaSelector = state => state.meta;
const topifyPresetsSelector = state => state.topifyPresets;
const userStateSelector = state => state.ustate;
const routingSelector = state => state.routing;
const uiSelector = state => state.ui;

export default createSelector(
	[ metaSelector, topifyPresetsSelector, userStateSelector, routingSelector, uiSelector ],
	( meta, topifyPresets, ustate, routing, ui ) => {
		return {
			isOpen: ui.sidebarOpened,
			meta: meta,
			ustate: ustate,
			custom_links: topifyPresets.forumSite.custom_links,
			forumSiteUrl: topifyPresets.forumSite.url,
			isVS: topifyPresets.forumSite.isVS,
			routing: routing
		}
	}
);



// WEBPACK FOOTER //
// ./src/selectors/sidebarSelector.js